import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { DataDictionaryTable } from "content/catalogue";

interface DataDictionaryProps {
  tables?: DataDictionaryTable[];
}

const HEADINGS: Record<DataDictionaryTable["kind"], [string, string, string]> = {
  fields: ["Name", "Data Type", "Description"],
  codes: ["Code", "Name", "Description"],
};

const rowsOf = (table: DataDictionaryTable): [string, string, string][] =>
  table.kind === "fields"
    ? table.fields.map((f) => [f.name, f.dataType, f.description])
    : table.codes.map((c) => [c.code, c.name, c.description]);

export const CatalogueEntryDataDictionary = ({
  tables,
}: DataDictionaryProps) => {
  if (!tables?.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Data Dictionary</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue={tables[0].name} className="w-full">
          <TabsList className="w-full justify-start gap-1 overflow-x-auto">
            {tables.map((table) => (
              <TabsTrigger key={table.name} value={table.name}>
                {table.name}
              </TabsTrigger>
            ))}
          </TabsList>
          {tables.map((table) => {
            const [first, second, third] = HEADINGS[table.kind];
            return (
              <TabsContent
                key={table.name}
                value={table.name}
                className="pt-4"
              >
                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>{first}</TableHead>
                        <TableHead>{second}</TableHead>
                        <TableHead>{third}</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {rowsOf(table).map(([a, b, c]) => (
                        <TableRow key={a}>
                          <TableCell className="font-mono text-xs align-top whitespace-nowrap">
                            {a}
                          </TableCell>
                          <TableCell className="text-muted-foreground align-top whitespace-nowrap">
                            {b}
                          </TableCell>
                          <TableCell className="align-top whitespace-normal">
                            {c}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>
            );
          })}
        </Tabs>
      </CardContent>
    </Card>
  );
};
